module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.addKey()
      }
    }
  }, [_vm._v("添加")]), _vm._v(" "), _vm._l((_vm.keyData), function(item, index) {
    return _c('div', {
      staticClass: "m-t-10"
    }, [_c('el-select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.field_name),
        expression: "item.field_name"
      }],
      staticClass: "w-150",
      attrs: {
        "placeholder": "请选择字段"
      },
      domProps: {
        "value": (item.field_name)
      },
      on: {
        "change": function($event) {
          _vm.fieldNameChange(item)
        },
        "input": function($event) {
          item.field_name = $event
        }
      }
    }, _vm._l((_vm.keyList), function(field) {
      return _c('el-option', {
        attrs: {
          "label": field.field,
          "value": field.field
        }
      }, [_vm._v("\n          " + _vm._s(field.field) + "-" + _vm._s(field.title) + "\n        ")])
    })), _vm._v(" "), _c('el-input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.show_name),
        expression: "item.show_name"
      }],
      staticClass: "w-110 m-l-5",
      domProps: {
        "value": (item.show_name)
      },
      on: {
        "input": function($event) {
          item.show_name = $event
        }
      }
    }), _vm._v(" "), _c('el-button', {
      staticClass: "m-l-5",
      attrs: {
        "type": "danger"
      },
      on: {
        "click": function($event) {
          _vm.deleteKey(index)
        }
      }
    }, [_vm._v("删除")])])
  })], true)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-10a1aff8!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Content/classify/foreignConfig.vue
// module id = 1772
// module chunks = 2